// extracted by mini-css-extract-plugin
module.exports = {"content":"DiscountCouponSection_content__BuYIQ","whiteInput":"DiscountCouponSection_whiteInput__10t5J","button":"DiscountCouponSection_button__18V4_"};